import { ChangeDetectorRef, Component, ComponentRef, ElementRef, EventEmitter, HostBinding, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { PreviewContentComponent } from './preview-content/preview-content.component';
import { FooterConfig, HeaderConfig, StorethemesModule } from '@urbannex/storethemes';
import { NbJSThemeOptions, NbLayoutModule, NbMenuItem, NbSidebarModule, NbTabsetModule, NbThemeService } from '@nebular/theme';
import { CommonModule, DOCUMENT } from '@angular/common';
// import { LayoutEditorService } from '../editors/layout-editor/layout-editor.service';
import { Observable, Subject, Subscription, interval, timer } from 'rxjs';
import { PreviewEditStoreService } from '../services/preview-edit-store.service';
import { LayoutEditorService } from '../editors/layout-editor/layout-editor.service';
import { map, take, takeUntil } from 'rxjs/operators';
import { Page, PageType, Section, Site, SiteHeader } from '../editor-container/editor-model';
import { PreviewModule } from './preview.module';
import { ActivatedRoute } from '@angular/router';
import { CssServicesService } from '../services/css-services.service';
import { IframeCommunicationService } from '../services/iframe-communication.service';
import { PreviewService } from './preview.service';
import { PreviewReceiptionService } from './preview-receiption.service';
import { PreviewDispatchService } from './services/preview-dispatch.service';
import { provideAnimations } from '@angular/platform-browser/animations';
// import { takeUntil } from 'rxjs/operators';
// import { LayoutEditorService } from '../editors/layout-editor/layout-editor.service';

// import { PreviewContentComponent } from '../preview/preview-content'

export interface SiteConfigMessage {
  id: string;
  data: Site[];
}

@Component({
  standalone: true,
  selector: 'kw-preview',
  imports: [
    CommonModule,
    NbLayoutModule,
    NbTabsetModule,
    StorethemesModule,
    NbSidebarModule,
    PreviewModule
  ],
  template: `
  <nb-layout>
    <nb-layout-header fixed>
      <ng-container *ngIf="headerSet">
        <ubs-header [headerConfig]="headerConfig" [menuItems]="menuItems"></ubs-header>
    </ng-container>
    </nb-layout-header>
    <nb-sidebar class="editor-sidebar" state="collapsed">
      Side Bar menu here
    </nb-sidebar>
    <nb-layout-column #mainLayoutContainer>
        <ng-container *ngIf="hasSections">
          <kw-render-preview-sections class="sections-container" #previewsContainer></kw-render-preview-sections>
        </ng-container>
    </nb-layout-column>
    <nb-layout-footer>
      <ng-container *ngIf="footerSet">
        <ubs-footer [footerConfig]="footerConfig"></ubs-footer>
  </ng-container>
    </nb-layout-footer>
  </nb-layout>
  `,
  styleUrls: ['./preview.component.scss'],
  providers: [PreviewEditStoreService, LayoutEditorService, CssServicesService, provideAnimations()],
})
export class PreviewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() styleSheets: any[];
  // @Input() currentTheme:string;
  currentTheme = "riding-hood";

  headerConfig: HeaderConfig;

  footerConfig: FooterConfig;

  headerSet = false;
  footerSet = false;

  menuItems: NbMenuItem[] = [
    {
      title: "Home",
      link: '/pages/home'
    },
    {
      title: "Category",
      link: '/pages/category'
    },
    {
      title: "About us",
      link: '/pages/about-us'
    },
    {
      title: "Checkout",
      link: '/pages/checkout'
    },
    {
      title: "FAQs",
      link: '/pages/faqs'
    },
    {
      title: "Policies",
      link: '/pages/policies'
    },
    {
      title: "Product",
      link: '/pages/product'
    }
  ]

  private destroy$: Subject<void> = new Subject<void>();

  selectedPage: Page;
  selectedSite: Site;
  sections: Section[];
  hasSections = false;
  bodyElement: HTMLElement;

  @ViewChild('mainLayoutContainer', { read: ElementRef }) mainLayoutContainer: ElementRef<HTMLElement>
  @ViewChild('previewsContainer', { read: ElementRef }) previewsContainer: ElementRef<HTMLElement>

  @ViewChild('iframe', { static: false }) iframe: HTMLIFrameElement;
  @Output() sendCss = new EventEmitter<any>();

  @HostBinding("style.--preview-sections-height") contentHeight: string;
  doc;
  compRef: ComponentRef<PreviewContentComponent>;
  currentComp: Type<PreviewComponent>;
  headerHeight: number;

  layoutSubscription: Subscription;
  storeSubscription: Subscription;
  receiveSiteConfig$: Subscription;
  receiveSelectedSite$: Subscription;
  updateSelectedSite$: Subscription;

  setSelectedPage$: Subscription;


  updateSelectedPage$: Subscription;
  selectedElementId$: Subscription;
  themeVariables$: Subscription;
  editElement$: Subscription;
  sectionThumbnails$: Subscription;
  gridCells$: Subscription;
  bodyHeight$: Subscription;
  headerConfig$: Subscription;
  theme$: Subscription;
  backgroundCSS$: Subscription;
  primaryColors$: Subscription;
  pageBgColor$: Subscription;
  txtColor$: Subscription;
  cellLayout$: Subscription;
  dlCellJson$: Subscription;
  snapShot$: Subscription;

  primaryFont$: Subscription;
  secondaryFont$: Subscription;

  checkStuff$: Subscription;

  firstLoad = true;

  previewSections: HTMLElement;


  // setSelectedPage$:Subscription;
  /* readonly setSelectedPage$ = this.communicator.receiveFromParent("selectedPage").pipe(
    takeUntil(this.destroy$),
    map(selectedPage => selectedPage)); */

  constructor(
    private el: ElementRef<HTMLElement>,
    private vcRef: ViewContainerRef,
    private themeService: NbThemeService,
    private previewEditStoreService: PreviewEditStoreService,
    private layoutEditorService: LayoutEditorService,
    private previewService: PreviewService,
    private communicator: IframeCommunicationService,
    private receiver: PreviewReceiptionService,
    private dispatcher: PreviewDispatchService,
    private cdr: ChangeDetectorRef) {
    this.layoutSubscription = this.layoutEditorService.getPallette().pipe(takeUntil(this.destroy$)).subscribe(pallette => {
      this.currentTheme = pallette;
      console.log({ CurrentTheme: this.currentTheme });
      this.themeService.changeTheme(this.currentTheme);
    })
    this.receiveSiteConfig$ = this.communicator.receiveFromParent("siteConfig").pipe(takeUntil(this.destroy$))
      .subscribe((siteConfigMessage: SiteConfigMessage) => {
        const sites = siteConfigMessage.data;
        if (sites != undefined) {
          console.log("receiving siteConfig")
          console.log(sites);
          // let sites = siteConfig["sites"];
          // if(sites != undefined){
          this.selectedSite = sites[0];
          console.log(this.selectedSite);
          if (this.selectedSite.theme != undefined && this.selectedSite.theme != null) {
            this.currentTheme = this.selectedSite.theme.name;
            this.themeService.changeTheme(this.currentTheme);
          }
          if (this.selectedSite.siteHeader != null && this.selectedSite.siteHeader != undefined) {
            this.headerConfig = this.selectedSite.siteHeader;
            this.headerSet = true;
          }
          if (this.selectedSite.siteFooter != null && this.selectedSite.siteFooter != undefined) {
            this.footerConfig = this.selectedSite.siteFooter;
            this.footerSet = true;
          }
          this.selectedPage = this.selectedSite.pages[0];
          this.sections = this.selectedPage.sections;
          this.previewService.setSections(this.sections);
          this.hasSections = true;
          this.cdr.detectChanges();
        }
        // }
      })
    /* this.receiveSelectedSite$ = this.communicator.receiveFromParent("selectedSite").pipe(takeUntil(this.destroy$))
    .subscribe((data) => {
      console.log("Receiving selectedSite")
      console.log(data)
    }) */
  }

  ngOnInit(): void {
    this.communicator.receiveFromParent("siteConfig").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(data);
      })
    /* this.receiveSiteConfig$ = this.communicator.receiveFromParent("siteConfig").pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      let siteConfig = data["data"];
      if(siteConfig != undefined){
        console.log("receiving siteConfig")
        console.log(data);
        const sites = siteConfig["sites"];
        if(sites != undefined){
          this.selectedSite = sites[0];
          console.log(this.selectedSite);
          if(this.selectedSite.theme != undefined && this.selectedSite.theme != null){
            this.currentTheme = this.selectedSite.theme.name;
            this.themeService.changeTheme(this.currentTheme);
          }
          if(this.selectedSite.siteHeader != null && this.selectedSite.siteHeader != undefined){
            this.headerConfig = this.selectedSite.siteHeader;
            this.headerSet = true;
          }
          if(this.selectedSite.siteFooter != null && this.selectedSite.siteFooter != undefined){
            this.footerConfig = this.selectedSite.siteFooter;
            this.footerSet = true;
          }
          this.selectedPage = this.selectedSite.pages[0];
          this.sections = this.selectedPage.sections;
          this.previewService.setSections(this.sections);
          this.hasSections = true;
          this.cdr.detectChanges();
        }
      }
    }) */
    this.updateSelectedSite$ = this.communicator.receiveFromParent("selectedSite").pipe(takeUntil(this.destroy$))
      .subscribe((info: any) => {
        console.log("Receiving selected site", info.data)
        console.log(info);
        // clean up existing sections
        this.previewService.setSections([]);
        this.selectedSite = info.data;
        this.currentTheme = this.selectedSite.theme.name ? this.selectedSite.theme.name : "default";
        this.themeService.changeTheme(this.currentTheme);
        const backGroundColors = this.previewService.getBackgrounds(this.bodyElement);
        this.communicator.send({ id: 'backgrounds', data: { options: backGroundColors } })
        const primaryColors = this.previewService.getColorScheme(this.bodyElement);
        this.communicator.send({ id: 'colorScheme', data: { options: primaryColors } })
        if (this.selectedSite.siteHeader != null && this.selectedSite.siteHeader != undefined) {
          this.headerConfig = this.selectedSite.siteHeader;
          this.headerSet = true;
        }
        this.selectedPage = this.selectedSite.pages[0];
        this.sections = this.selectedPage.sections;
        // Reset sections
        this.previewService.setSections(this.sections);
        console.log("Sections updated", this.sections)
        this.hasSections = true;
        this.cdr.detectChanges();
        this.updateColors();
        /* this.dispatcher.getSectionThumbnails().pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          this.communicator.send({id:"thumbs",data:data});
        }) */
      })

    this.updateSelectedPage$ = this.communicator.receiveFromParent("updateSelectedPage").pipe(takeUntil(this.destroy$))
      .subscribe((info: any) => {
        // console.log(JSON.stringify(info.sections[0].sectionData.gridOptions.gridCells));
        // console.log(info)
        this.sections = info.sections; // this.selectedPage.sections;
        this.previewService.setSections(info.sections);
        console.log("Info", info, "Sections updated", this.sections)


        if (!this.firstLoad) {
          this.bodyHeight$ = interval(100).pipe(takeUntil(timer(40000))).subscribe(() => {
            // console.log("Body ScrollHeight After Later: "+this.bodyElement.clientHeight);
            this.communicator.send({ id: 'contentHeight', data: this.mainLayoutContainer.nativeElement.clientHeight })
          })
        }

        this.cdr.detectChanges();
        /* setTimeout(() => {
          console.log(info);
        this.selectedPage = info.data;
        this.sections = this.selectedPage.sections;
          this.previewService.setSections([]);
          this.previewService.setSections(this.sections);
          this.hasSections = true;
          //this.cdr.detectChanges();
        },100 )*/

      })
    /* this.setSelectedPage$.subscribe((info:any) => {
      console.log(info.data);
      let selectedPage:Page = info.data;
      this.sections = selectedPage.sections;

      this.selectedPage = info.data;
        this.sections = this.selectedPage.sections;
        this.hasSections = false;
        this.previewService.setSections([]);
        this.previewService.setSections(this.sections);
        this.hasSections = true;
        this.cdr.detectChanges();
    }) */
    this.setSelectedPage$ = this.communicator.receiveFromParent("selectedPage").pipe(takeUntil(this.destroy$))
      .subscribe((info: any) => {
        console.log(info.data);
        const selectedPage: Page = info.data;
        this.sections = selectedPage.sections;

        this.selectedPage = info.data;
        this.sections = this.selectedPage.sections;
        this.hasSections = false;
        this.previewService.setSections([]);
        this.previewService.setSections(this.sections);
        this.hasSections = true;
        this.cdr.detectChanges();
      })
    this.themeVariables$ = this.themeService.getJsTheme().pipe(takeUntil(this.destroy$)).subscribe((themeOptions: NbJSThemeOptions) => {
      this.communicator.send({ id: "themeVariables", data: themeOptions })
    });
    this.selectedElementId$ = this.communicator.receiveFromParent("selectedElId").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        /**
         * Sanity check:
         * quesrySelectory by id doesn't work if the id contains a period.
         * Check if id contained in the data contains a dot.
         * If it does, escape the dot before using querySelector
         * Else query
         */
        console.log(`Track Selected Element: ${data.data}`)
        // let idString = this.escapeDotInString(data.data);
        // console.log(`Track Selected Element: ${data.data}`)
        this.receiver.selectElement(this.el.nativeElement, data.data);
        const selectedEl = <HTMLElement>this.el.nativeElement.querySelector('[id="' + data.data + '"]');
        console.log(selectedEl);
        console.log("currentPosition", selectedEl.offsetTop);

        setTimeout(() => {
          selectedEl.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'start',
          });
          // Then request the parent to adjust for the header
          setTimeout(() => {
            this.requestParentScrollAdjustment();
          }, 300); // Wait for scrollIntoView to complete

        }, 0);

      })

    this.communicator.receiveFromParent("delectedElId").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.receiver.deleteElement(this.el.nativeElement, data.data)
      })
    this.communicator.receiveFromParent("hideEl").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.receiver.hideElement(this.el.nativeElement, data.data)
      })
    this.communicator.receiveFromParent("showEl").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.receiver.showElement(this.el.nativeElement, data.data)
      })
    this.editElement$ = this.communicator.receiveFromParent("editEl").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.receiver.editSelect(this.el.nativeElement, data.data)
      })
    this.snapShot$ = this.communicator.receiveFromParent("snapShot").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.receiver.downloadSectionImage(this.el, data.data);
      })
    this.sectionThumbnails$ = this.dispatcher.getSectionThumbnails().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.communicator.send({ id: "thumbs", data: data });
      })
    this.gridCells$ = this.dispatcher.getCellIdsThumbs().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(data);
        this.communicator.send({ id: "cellIdsThumbs", data: data })
      })
    /* this.layoutSubscription = this.layoutEditorService.getPallette().pipe(takeUntil(this.destroy$)).subscribe(pallette => {
      this.currentTheme = pallette;
      console.log(this.currentTheme);
      this.themeService.changeTheme(this.currentTheme);
    }) */

    // this.themeService.changeTheme(this.currentTheme);
    /* this.previewEditStoreService.layoutState$.subscribe((layoutState:LayoutState) => {
      this.currentTheme = layoutState.pallette;
      this.themeService.changeTheme(this.currentTheme);
    }) */
    this.storeSubscription = this.previewEditStoreService.layoutState$.pipe(takeUntil(this.destroy$)).subscribe(layoutState => {
      console.log(layoutState);
    });
    this.headerConfig$ = this.communicator.receiveFromParent("headerConfig").pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        // console.log("Getting HeaderConfig")
        this.headerConfig = data["data"];
        // console.log(this.headerConfig);
        this.cdr.detectChanges();
      })
    this.theme$ = this.communicator.receiveFromParent("themeConfig").pipe(takeUntil(this.destroy$))
      .subscribe((payload: any) => {
        // console.log(payload);
        this.themeService.changeTheme(payload.data.name);
        const backGroundColors = this.previewService.getBackgrounds(this.bodyElement);
        // console.log(backGroundColors);
        this.communicator.send({ id: 'backgrounds', data: { options: backGroundColors } })
        const primaryColors = this.previewService.getColorScheme(this.bodyElement);
        this.communicator.send({ id: 'colorScheme', data: { options: primaryColors } })
      })
    this.pageBgColor$ = this.communicator.receiveFromParent("pageBgColor").pipe(takeUntil(this.destroy$))
      .subscribe((payload: any) => {
        // console.log(this.themeService.currentTheme);
        // console.log(payload);
        this.bodyElement.style.setProperty("--background-page-color", payload.data)
      })
    this.txtColor$ = this.communicator.receiveFromParent("txtColor").pipe(takeUntil(this.destroy$))
      .subscribe((payload: any) => {
        // console.log(this.themeService.currentTheme);
        // console.log(payload);
        this.bodyElement.style.setProperty("--layout-text-color", payload.data)
      })
    this.primaryFont$ = this.communicator.receiveFromParent("primaryFont").pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        // console.log(payload)
        this.bodyElement.style.setProperty("--font-family-primary", payload.value)
      })
    this.secondaryFont$ = this.communicator.receiveFromParent("secondaryFont").pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        // console.log(payload)
        this.bodyElement.style.setProperty("--font-family-secondary", payload.value)
      })

  }

  resolvePage(selectedSite: Site, pageType: PageType) {
    let selectedPage = null;
    selectedSite.pages.forEach(page => {
      if (page.pageType == pageType) {
        selectedPage = page;
      }
    })
    return selectedPage;
  }

  ngAfterViewInit(): void {
    /* this.checkStuff$ = this.communicator.receiveFromParent("siteConfig").pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log(data);
        let siteConfig = data["data"];
        if(siteConfig != undefined){
          const sites = siteConfig["sites"];
          if(sites != undefined){
            this.selectedSite = sites[0];
            console.log(this.selectedSite);
            if(this.selectedSite.theme != undefined && this.selectedSite.theme != null){
              this.currentTheme = this.selectedSite.theme.name;
              this.themeService.changeTheme(this.currentTheme);
            }
            if(this.selectedSite.siteHeader != null && this.selectedSite.siteHeader != undefined){
              this.headerConfig = this.selectedSite.siteHeader;
              this.headerSet = true;
            }
            this.selectedPage = this.selectedSite.pages[0];
            this.sections = this.selectedPage.sections;
            this.previewService.setSections(this.sections);
            this.hasSections = true;
            this.cdr.detectChanges();
          }
        }
    }) */
    let parentHost = this.el.nativeElement.parentElement;
    while (parentHost.tagName != "BODY") {
      parentHost = parentHost.parentElement;
    }
    if (parentHost.tagName == "BODY") {
      this.bodyElement = parentHost;
    }
    let nb_theme_class: string = "nb-theme-default";
    if (this.currentTheme != null) {
      nb_theme_class = "nb-theme-" + this.currentTheme;
    }
    // this.bodyElement.classList.add(nb_theme_class);
    const rs = getComputedStyle(this.bodyElement);
    /* let r = <HTMLElement>this.document.querySelector(nb_theme_class);
    var rs = getComputedStyle(r); */
    // console.log("R: The value of --layout-content-width is: " + rs.getPropertyValue('--layout-content-width'));
    // console.log("BodyElement: The value of --layout-content-width is: " + ry.getPropertyValue('--layout-content-width'));
    // this.bodyElement.style.setProperty('--layout-content-width',"1000px");
    // console.log("The value of After is: " + rs.getPropertyValue('--layout-content-width'));
    // let headerHost = <HTMLElement>(this.el.nativeElement.getElementsByTagName('nb-layout-header'))[0];
    // this.bodyElement.style.setProperty('--header-height',headerHost.offsetHeight+"px");

    const styles = getComputedStyle(this.bodyElement);
    // console.log(styles);
    const layoutBackgroundColor = styles.getPropertyValue('--layout-background-color');
    // console.log(layoutBackgroundColor)
    const pageBgColor = this.previewService.getPageBackground(this.bodyElement);
    const borderColors = this.previewService.getBorderColors(this.bodyElement);
    const backGroundColors = this.previewService.getBackgrounds(this.bodyElement);
    // console.log(backGroundColors)
    const colorScheme = this.previewService.getColorScheme(this.bodyElement);
    const textColor = this.previewService.getLayoutTextColor(this.bodyElement);
    const fontFamilies = this.previewService.getFontFamilies(this.bodyElement);
    // console.log({backgroundBasicColor1:backgroundBasicColor1,layoutBackgroundColor:layoutBackgroundColor});
    this.communicator.send({
      id: "css", data: {
        current: layoutBackgroundColor, options: {
          backgroundBasicColor1: styles.getPropertyValue('--background-basic-color-1'),
          backgroundBasicColor2: styles.getPropertyValue('--background-basic-color-2'),
          backgroundBasicColor3: styles.getPropertyValue('--background-basic-color-3'),
          backgroundBasicColor4: styles.getPropertyValue('--background-basic-color-4'),
          backgroundPrimaryColor1: styles.getPropertyValue('--background-primary-color-1'),
          backgroundPrimaryColor2: styles.getPropertyValue('--background-primary-color-2'),
          backgroundPrimaryColor3: styles.getPropertyValue('--background-primary-color-3'),
          backgroundPrimaryColor4: styles.getPropertyValue('--background-primary-color-4'),
          backgroundAlternativeColor1: styles.getPropertyValue('--background-alternative-color-1'),
          backgroundAlternativeColor2: styles.getPropertyValue('--background-alternative-color-2'),
          backgroundAlternativeColor3: styles.getPropertyValue('--background-alternative-color-3'),
          backgroundAlternativeColor4: styles.getPropertyValue('--background-alternative-color-4')
        }
      }
    }, parent);
    setTimeout(() => {
      this.communicator.send({ id: 'pageBgColor', data: pageBgColor });
      this.communicator.send({ id: 'txtColor', data: textColor })
      this.communicator.send({ id: 'borders', data: { options: borderColors } })
      this.communicator.send({ id: 'backgrounds', data: { options: backGroundColors } })
      this.communicator.send({ id: 'colorScheme', data: { options: colorScheme } })
      this.communicator.send({ id: 'fontFamilies', data: { options: fontFamilies } });
    }, 500)

    setTimeout(() => {
      this.mainLayoutContainer.nativeElement.classList.add("full-width");
      this.previewSections = this.mainLayoutContainer.nativeElement.querySelector('sections-container')
      console.log("Setting preview height: " + this.previewSections);

      // this.communicator.send({id:'contentHeight',data:this.mainLayoutContainer.nativeElement.clientHeight})
      console.log("Body ScrollHeight Before Timing: " + this.bodyElement.scrollHeight);
      this.bodyHeight$ = interval(100).pipe(takeUntil(timer(60000))).subscribe(() => {
        // this.contentHeight = this.mainLayoutContainer.nativeElement.clientHeight+200+"px"
        // previewSections.style.height = this.mainLayoutContainer.nativeElement.clientHeight+"px";
        this.communicator.send({ id: 'contentHeight', data: this.mainLayoutContainer.nativeElement.clientHeight })
        this.firstLoad = false;
      })
    }, 500);
    // this.mainLayoutContainer.nativeElement.clientHeight

    this.backgroundCSS$ = this.themeService.onThemeChange().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        const backGroundColors = this.previewService.getBackgrounds(this.bodyElement);
        this.communicator.send({ id: 'backgrounds', data: { options: backGroundColors } })
        const pageBgColor = this.previewService.getPageBackground(this.bodyElement);
        this.communicator.send({ id: 'pageBgColor', data: pageBgColor })
        const textColor = this.previewService.getLayoutTextColor(this.bodyElement)
        this.communicator.send({ id: 'txtColor', data: textColor })
      })
    this.primaryColors$ = this.themeService.onThemeChange().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        const primaryColors = this.previewService.getColorScheme(this.bodyElement);
        this.communicator.send({ id: 'colorScheme', data: { options: primaryColors } })
      })
    /* this.cellLayout$ = this.communicator.receiveFromParent("cellLayout").pipe(takeUntil(this.destroy$))
    .subscribe(payLoad => {
      const section:Section = payLoad["data"]["section"];
      const targetEl = payLoad["data"]["elId"]
      //const parentElId = section.sectionId;
      const cellId = payLoad["data"]["cellId"];
      let layoutThumbnails:any[] = this.receiver.getCellLayoutThumbs(this.el.nativeElement,targetEl,section,cellId);
      console.log(layoutThumbnails.length);
      setTimeout(() => {
          console.log(layoutThumbnails);
          this.communicator.send({id:"cellLayoutThumbs",data:layoutThumbnails});
      }, 3000);


    }) */

    this.dlCellJson$ = this.communicator.receiveFromParent("dlCellThumb").pipe(takeUntil(this.destroy$))
      .subscribe(payLoad => {
        const targetEl = payLoad["data"]["elId"];
        const cellId = payLoad["data"]["cellId"];
        const dlCellJson = this.receiver.getCellJson(this.el.nativeElement, targetEl, cellId)
      })
  }

  onLoad(iframe) {
    this.doc = iframe.contentDocument || iframe.contentWindow;
    // this.createComponent();

  }

  createComponent() {
    this.compRef = this.vcRef.createComponent(PreviewContentComponent);
    this.compRef.location.nativeElement.id = 'innerComp';
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  updateColors() {
    const rs = getComputedStyle(this.bodyElement);
    const styles = getComputedStyle(this.bodyElement);
    const layoutBackgroundColor = styles.getPropertyValue('--layout-background-color');
    console.log(layoutBackgroundColor)
    const pageBgColor = this.previewService.getPageBackground(this.bodyElement);
    const borderColors = this.previewService.getBorderColors(this.bodyElement);
    const backGroundColors = this.previewService.getBackgrounds(this.bodyElement);
    console.log(backGroundColors)
    const colorScheme = this.previewService.getColorScheme(this.bodyElement);
    const textColor = this.previewService.getLayoutTextColor(this.bodyElement);
    const fontFamilies = this.previewService.getFontFamilies(this.bodyElement);
    // console.log({backgroundBasicColor1:backgroundBasicColor1,layoutBackgroundColor:layoutBackgroundColor});
    this.communicator.send({
      id: "css", data: {
        current: layoutBackgroundColor, options: {
          backgroundBasicColor1: styles.getPropertyValue('--background-basic-color-1'),
          backgroundBasicColor2: styles.getPropertyValue('--background-basic-color-2'),
          backgroundBasicColor3: styles.getPropertyValue('--background-basic-color-3'),
          backgroundBasicColor4: styles.getPropertyValue('--background-basic-color-4'),
          backgroundPrimaryColor1: styles.getPropertyValue('--background-primary-color-1'),
          backgroundPrimaryColor2: styles.getPropertyValue('--background-primary-color-2'),
          backgroundPrimaryColor3: styles.getPropertyValue('--background-primary-color-3'),
          backgroundPrimaryColor4: styles.getPropertyValue('--background-primary-color-4'),
          backgroundAlternativeColor1: styles.getPropertyValue('--background-alternative-color-1'),
          backgroundAlternativeColor2: styles.getPropertyValue('--background-alternative-color-2'),
          backgroundAlternativeColor3: styles.getPropertyValue('--background-alternative-color-3'),
          backgroundAlternativeColor4: styles.getPropertyValue('--background-alternative-color-4')
        }
      }
    }, parent);
  }

  escapeDotInString(inputString) {
    // Check if the string contains a period
    if (inputString.includes('.')) {
      // Use the replace method with a regular expression to escape each period
      return inputString.replace(/\./g, '\\.');
    }
    // If no period is found, return the original string
    return inputString;
  }

  // Example usage
  // let originalString = "example.string.with.period";
  // let escapedString = escapeDotInString(originalString);

  // console.log("Original:", originalString);  // Output: example.string.with.period
  // console.log("Escaped:", escapedString);    // Output: example\.string\.with\.period

  private requestParentScrollAdjustment(): void {
    const headerHeight = this.getHeaderHeight();

    // Send message to parent to adjust scroll position
    this.communicator.send({
      id: 'adjust-scroll-for-header',
      data: {
        headerOffset: headerHeight,
        timestamp: Date.now()
      }
    });
  }

  private getHeaderHeight(): number {
    // Try to get header height - since we're in iframe, use a reasonable default
    // The parent will have the actual header element
    return 60; // Default header height - the parent will use the actual value
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
